import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Monthlycorporatecabrental() {



  const cardData =
  {
    keyword: 'Monthly Corporate Cab Rentals in Pune',
    heading: 'Aaryan Travels: Monthly Corporate Cab Rentals in Pune',
    headingDescription: ' Aaryan Travels provides reliable Monthly Corporate Cab Rentals in Pune for IT companies, manufacturing units, and corporate professionals who require consistent and punctual transportation. Whether it’s daily employee commuting, executive transfers, airport pickups, or inter-office travel, our fleet of sedans, SUVs, and tempo travellers is available on fixed monthly contracts with transparent billing. With uniformed chauffeurs, GPS-enabled vehicles, on-time reporting, and 24/7 support, we ensure seamless mobility across major business zones like Hinjewadi, Kharadi, Magarpatta, Baner, and Pimpri-Chinchwad. Aaryan Travels eliminates the hassle of daily bookings with customized long-term corporate cab rental solutions in Pune.',

    top: 'Top Places to Visit in Pune with Aaryan Travels',

 "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada is Pune’s most iconic fort palace. It once served as the seat of the Maratha Empire and still echoes the legacy of Bajirao and Mastani. Visitors explore its grand gateways, fountains, and spacious gardens. Although partially destroyed by fire, the ruins retain their historic charm. The evening light-and-sound show brings Maratha history to life. Shaniwar Wada is Pune’s proud symbol of heritage."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a majestic monument associated with India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. The palace now serves as a museum displaying their personal belongings. Its Italian arches and lush lawns add to the beauty. Aga Khan Palace is Pune’s inspiring monument of sacrifice and peace."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located about 25 km from Pune, is famed for the 1670 battle where Tanaji Malusare laid down his life for Chhatrapati Shivaji Maharaj. The hilltop fort offers breathtaking views of the Sahyadri range. Trekking to the top is popular among adventure enthusiasts. Local vendors serve piping-hot pithla-bhakri and lemon juice. Sinhagad is Pune’s perfect blend of history and adventure."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine dedicated to Lord Ganesha. The beautifully adorned idol, covered in gold ornaments, attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the center of grand festivities. Devotees experience deep spiritual peace inside. Dagdusheth Ganpati is Pune’s divine heart of devotion."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva. Its monolithic pillars, sanctum, and Nandi mandapa reflect ancient Indian craftsmanship. Despite being in the city’s center, it offers a peaceful and meditative atmosphere. Evening prayers enhance the spiritual vibes. Pataleshwar is Pune’s hidden gem of sacred history."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar. Exhibits include sculptures, musical instruments, ornaments, and everyday antiques from Indian households. The recreated Mastani Mahal is a major attraction. History enthusiasts find it deeply fascinating. The museum is Pune’s cultural treasure chest."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is a sacred spot offering panoramic views of Pune city. The hilltop houses a historic temple dedicated to Lord Shiva and Goddess Parvati. Visitors climb 103 stone steps to reach the shrine, combining devotion with fitness. The sunrise and sunset views from the summit are breathtaking. Parvati Hill is Pune’s serene spiritual viewpoint."
  },
  {
    "title": "Osho Ashram",
    "description": "Osho Ashram in Koregaon Park is an international meditation resort that attracts seekers from around the world. Spread across peaceful gardens, it offers sessions in meditation, wellness, and personal growth. The serene ambiance and artistic architecture create a tranquil retreat. Visitors experience rejuvenation and mindfulness. Osho Ashram is Pune’s oasis of inner peace."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden is Pune’s largest landscaped park, inspired by Japan’s Korakuen Garden. It features flowing streams, stone bridges, and manicured lawns. Families enjoy peaceful walks, picnics, and photography sessions. Seasonal flowers add vibrant charm throughout the year. The garden is Pune’s green paradise of calmness."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular picnic and weekend getaway near Pune. During monsoon, overflowing waters and misty surroundings create a picturesque view. Vendors selling hot corn and tea enhance the experience. It is also the gateway to Sinhagad Fort. Khadakwasla is Pune’s refreshing escape into nature."
  }
],


"services": [
  {
    "name": "Monthly Corporate Cab Rentals in Pune",
    "description": "Monthly Corporate Cab Rentals in Pune provide businesses with flexible and cost-effective transportation solutions tailored for long-term needs. Designed for companies that require regular employee commutes, client transfers, or executive travel, our service offers well-maintained vehicles with professional chauffeurs. Enjoy the convenience of fixed monthly pricing, priority booking, and customized routes, ensuring seamless and punctual transport for your corporate operations."
  },
  {
    "name": "Pune Monthly Corporate Cab Hire",
    "description": "Pune Monthly Corporate Cab Hire is ideal for organizations seeking dependable and consistent transportation for their workforce or executives. Our monthly packages include sedans, SUVs, and premium cars, all operated by experienced drivers. With easy online booking, real-time tracking, and transparent billing, businesses can streamline travel management while offering employees a comfortable and safe ride."
  },
  {
    "name": "Long Term Corporate Cab Pune",
    "description": "Long Term Corporate Cab Pune services cater to businesses needing sustained transportation solutions over extended periods. Whether for staff shuttles, client visits, or executive transfers, our service ensures reliable vehicles, punctual chauffeurs, and tailored scheduling. Benefit from flexible contract terms, dedicated account management, and comprehensive support to meet evolving corporate travel demands."
  },
  {
    "name": "Corporate Taxi Subscription Pune",
    "description": "Corporate Taxi Subscription Pune offers an innovative subscription-based model that simplifies business travel. Companies can subscribe to fixed monthly plans providing access to a fleet of taxis with chauffeur services, allowing hassle-free booking, priority availability, and cost savings. This service is perfect for dynamic businesses requiring scalable and efficient transportation without the burden of daily bookings."
  },
  {
    "name": "Chauffeur Corporate Cab Pune Monthly",
    "description": "Chauffeur Corporate Cab Pune Monthly service delivers premium chauffeur-driven vehicles for all your corporate travel needs. Our professional drivers are trained in etiquette, safety, and discretion, ensuring a pleasant experience for executives and important clients. With monthly contracts, companies can guarantee reliable and comfortable transport tailored to their schedules and preferences."
  },
  {
    "name": "Affordable Monthly Corporate Cab Pune",
    "description": "Affordable Monthly Corporate Cab Pune combines cost-efficiency with quality service to provide budget-friendly monthly cab rentals. Ideal for startups, SMEs, and large enterprises alike, this service offers well-maintained vehicles and courteous drivers without compromising on safety or comfort. Optimize your corporate travel expenses while maintaining high standards of service."
  },
  {
    "name": "Executive Corporate Cab Pune",
    "description": "Executive Corporate Cab Pune specializes in providing luxury sedans and SUVs with chauffeur services for senior management and VIP clients. Our executive fleet features premium amenities designed to enhance comfort and productivity during travel. Whether for airport pickups, business meetings, or corporate events, this service ensures a sophisticated and punctual journey."
  },
  {
    "name": "Corporate Staff Transport Pune",
    "description": "Corporate Staff Transport Pune focuses on the efficient movement of employees across multiple shifts and locations. We offer customized route planning, GPS tracking, and reliable pick-up/drop-off services to enhance workforce punctuality and reduce absenteeism. Our monthly plans provide businesses with scalable and dependable transport solutions tailored to their operational needs."
  },
  {
    "name": "Business Cab Pune Monthly",
    "description": "Business Cab Pune Monthly service offers companies a hassle-free way to manage their corporate transportation with fixed monthly rentals. Our fleet includes a range of vehicles suitable for various business requirements, supported by experienced chauffeurs who prioritize safety and punctuality. Flexible packages and transparent billing make this an ideal choice for efficient corporate mobility."
  },
  {
    "name": "Office Cab Hire Pune",
    "description": "Office Cab Hire Pune provides daily commute solutions for office employees, ensuring timely and comfortable transportation. Our monthly hire plans include route optimization, shift-wise scheduling, and detailed reporting to help businesses manage staff travel efficiently. With a focus on safety and reliability, we aim to reduce commute-related stress and improve overall employee satisfaction."
  },
  {
    "name": "Corporate Vehicle Rental Pune",
    "description": "Corporate Vehicle Rental Pune offers a wide selection of cars and SUVs for corporate use on a monthly basis. Our rentals come with the option of professional drivers, flexible contract terms, and dedicated support to ensure smooth operations. Whether for client transport or employee commutes, our service is designed to meet diverse business travel requirements."
  },
  {
    "name": "Monthly Business Cab Pune",
    "description": "Monthly Business Cab Pune is tailored for companies needing regular and reliable transportation solutions. Our monthly cab plans provide fixed pricing, priority booking, and a range of vehicle options to suit different business needs. Professional drivers and real-time vehicle tracking enhance security and punctuality, making this service an excellent choice for sustained corporate travel."
  },
  {
    "name": "Online Corporate Cab Monthly Pune",
    "description": "Online Corporate Cab Monthly Pune enables businesses to conveniently manage their monthly cab bookings through a digital platform. Schedule rides, monitor usage, and generate invoices all online, streamlining travel management for admin teams. This service ensures quick booking confirmations and easy adjustments to meet dynamic corporate transport needs."
  },
  {
    "name": "Corporate Car Leasing Pune",
    "description": "Corporate Car Leasing Pune provides flexible leasing options for companies looking to maintain a fleet without the hassles of ownership. With monthly leases including maintenance, insurance, and driver services, businesses can focus on operations while enjoying reliable corporate transportation. Our leasing plans are customizable to accommodate various vehicle types and contract durations."
  },
  {
    "name": "Monthly Corporate Cab Plans Pune",
    "description": "Monthly Corporate Cab Plans Pune offer structured and scalable transportation packages designed to fit any company size and budget. From basic commuter plans to premium executive travel, our packages include priority support, vehicle variety, and transparent pricing. These plans simplify corporate travel logistics, ensuring smooth day-to-day operations with dependable cab services."
  }
],
"tableData": [
  ["Monthly Corporate Cab Rentals in Pune", "Pune Monthly Corporate Cab Hire"],
  ["Long Term Corporate Cab Pune", "Corporate Taxi Subscription Pune"],
  ["Chauffeur Corporate Cab Pune Monthly", "Affordable Monthly Corporate Cab Pune"],
  ["Executive Corporate Cab Pune", "Corporate Staff Transport Pune"],
  ["Business Cab Pune Monthly", "Office Cab Hire Pune"],
  ["Corporate Vehicle Rental Pune", "Monthly Business Cab Pune"],
  ["Online Corporate Cab Monthly Pune", "Corporate Car Leasing Pune"],
  ["Monthly Corporate Cab Plans Pune", "—"]
],

"whychoose": [
  {
    "WhyChooseheading": "Reliable Monthly Corporate Cab Rentals in Pune",
    "WhyChoosedescription": "Aaryan Travels offers dependable monthly corporate cab rental services tailored to businesses in Pune."
  },
  {
    "WhyChooseheading": "Punctual Pickup and Drop for Seamless Commutes",
    "WhyChoosedescription": "Ensure timely transportation for your employees and clients across Pune with our professional service."
  },
  {
    "WhyChooseheading": "Clean and Comfortable Vehicles for Business Travel",
    "WhyChoosedescription": "Travel in sanitized, air-conditioned cabs maintained to meet corporate standards."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Pune’s Corporate Routes",
    "WhyChoosedescription": "Our drivers know Pune well to provide efficient and hassle-free rides for your business needs."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy upfront pricing including GST-compliant invoices, covering fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Dedicated Customer Support",
    "WhyChoosedescription": "Our support team is available around the clock to assist with bookings, changes, and inquiries."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans to Suit Your Business Requirements",
    "WhyChoosedescription": "Choose from daily, weekly, or monthly cab hire contracts customized for your organization."
  },
  {
    "WhyChooseheading": "Wide Fleet of Vehicles for Corporate Travel",
    "WhyChoosedescription": "Select from sedans, SUVs, and tempo travellers based on your team size and preferences."
  }
]

































  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer monthly corporate cab rentals in Pune?',
    answer: 'Yes, Aaryan Travels provides convenient and cost-effective monthly corporate cab rental services in Pune tailored for businesses.',
  },
  {
    question: 'How can I book monthly corporate cab rentals in Pune with Aaryan Travels?',
    answer: 'You can easily book monthly rentals through our website, mobile app, or by contacting our corporate support team.',
  },
  {
    question: 'What types of vehicles are available for monthly corporate cab rentals in Pune?',
    answer: 'Aaryan Travels offers a wide range of vehicles including sedans, SUVs, and premium cars suitable for corporate use.',
  },
  {
    question: 'Are monthly corporate cab rentals suitable for daily employee commute in Pune?',
    answer: 'Yes, our monthly rental packages are designed for daily employee pickups and drops across Pune with flexible terms.',
  },
  {
    question: 'Are drivers experienced and trained for monthly corporate rentals in Pune?',
    answer: 'Absolutely. Our drivers are professionally trained, courteous, and familiar with Pune’s corporate travel requirements.',
  },
  {
    question: 'Can Aaryan Travels handle bulk or group monthly corporate cab bookings in Pune?',
    answer: 'Yes, we manage group transportation and bulk monthly bookings for corporate meetings, events, and employee commutes.',
  },
  {
    question: 'Do you offer monthly billing or invoice options for monthly corporate cab rentals in Pune?',
    answer: 'Yes, flexible monthly billing and invoicing options are available for corporate clients.',
  },
  {
    question: 'Is monthly corporate cab rental service available 24x7 in Pune?',
    answer: 'Yes, Aaryan Travels provides 24x7 monthly corporate cab rental services in Pune for uninterrupted business travel.',
  },
  {
    question: 'What safety measures are in place for monthly corporate cab rentals in Pune?',
    answer: 'All vehicles undergo regular sanitization, and drivers follow strict safety protocols to ensure passenger safety.',
  },
  {
    question: 'Can pickup and drop-off locations be customized for monthly corporate cab rentals in Pune?',
    answer: 'Yes, pickup and drop-off locations can be fully customized according to your corporate travel plans.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Aditya Kulkarni',
    feedback: 'Aaryan Travels’ monthly corporate cab rentals in Pune have streamlined our employee commute with reliable service.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Sneha Patil',
    feedback: 'Highly satisfied with the monthly rental options provided by Aaryan Travels. Great flexibility and excellent drivers.',
    rating: 5,
  },
];




















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];









const monthlyCorporateCabSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Monthly Corporate Cab Rentals in Pune",
  "description": "Aaryan Travels provides affordable and reliable monthly corporate cab rentals in Pune, offering chauffeur-driven vehicles for office staff transport, business travel, and long-term corporate cab subscriptions.",
  "provider": {
    "@type": "Organization",
    "name": "Aaryan Travels",
    "url": "https://aaryantravels.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "serviceType": "Monthly Corporate Cab Rentals",
  "keywords": "Monthly Corporate Cab Rentals in Pune, Pune Monthly Corporate Cab Hire, Long Term Corporate Cab Pune, Corporate Taxi Subscription Pune, Chauffeur Corporate Cab Pune Monthly, Affordable Monthly Corporate Cab Pune, Executive Corporate Cab Pune, Corporate Staff Transport Pune, Business Cab Pune Monthly, Office Cab Hire Pune, Corporate Vehicle Rental Pune, Monthly Business Cab Pune, Online Corporate Cab Monthly Pune, Corporate Car Leasing Pune, Monthly Corporate Cab Plans Pune"
};






  return (
    <div>

<Helmet>
  <title>Monthly Corporate Cab Rentals in Pune | Affordable Business Cabs | Aaryan Travels</title>
  <meta
    name="description"
    content="Reliable and affordable monthly corporate cab rentals in Pune by Aaryan Travels. Chauffeur-driven cars for office staff, business travel, and corporate subscriptions."
  />
  <meta
    name="keywords"
    content="Monthly Corporate Cab Rentals in Pune, Pune Monthly Corporate Cab Hire, Long Term Corporate Cab Pune, Corporate Taxi Subscription Pune, Chauffeur Corporate Cab Pune Monthly, Affordable Monthly Corporate Cab Pune, Executive Corporate Cab Pune, Corporate Staff Transport Pune, Business Cab Pune Monthly, Office Cab Hire Pune, Corporate Vehicle Rental Pune, Monthly Business Cab Pune, Online Corporate Cab Monthly Pune, Corporate Car Leasing Pune, Monthly Corporate Cab Plans Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(monthlyCorporateCabSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/49.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Monthlycorporatecabrental;